import { Routes, Route, BrowserRouter } from "react-router-dom";

import DataExtraction from "./containers/DataExtraction";
import ViewExtractions from "./containers/ViewExtractions";
import ViewExtraction from "./containers/ViewExtractions/view";
import Login from "./containers/Login";
import ProtectedRoute from "./containers/ProtectedRoute";
import './App.css';

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/data-extraction" element={
                        <ProtectedRoute>
                            <DataExtraction />
                        </ProtectedRoute>
                    } />
                    <Route path="/view-extractions" element={
                        <ProtectedRoute>
                            <ViewExtractions />
                        </ProtectedRoute>
                    } />
                    <Route path="/view-extractions/:requestId" element={
                        <ProtectedRoute>
                            <ViewExtraction />
                        </ProtectedRoute>
                    } />
                </Routes>
            </BrowserRouter>
        </div>
    );
};

export default App;
